import { render, staticRenderFns } from "./RetornoBancarioFinanceiro.vue?vue&type=template&id=39f36f63&scoped=true&"
import script from "./retornoBancarioFinanceiro.js?vue&type=script&lang=js&"
export * from "./retornoBancarioFinanceiro.js?vue&type=script&lang=js&"
import style0 from "./RetornoBancarioFinanceiro.vue?vue&type=style&index=0&id=39f36f63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f36f63",
  null
  
)

export default component.exports